// tslint:disable
/**
 * MyProfileAPI
 * My Profile API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface Account
 */
export interface Account {
    /**
     * 
     * @type {Address}
     * @memberof Account
     */
    address?: Address;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    dateOfBirth?: string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    salutation?: string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    firstName?: string;
    /**
     * 
     * @type {number}
     * @memberof Account
     */
    cknr?: number;
    /**
     * 
     * @type {Email}
     * @memberof Account
     */
    email?: Email;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    lastName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Account
     */
    mobito?: boolean;
}
/**
 * 
 * @export
 * @interface AccountImageResponse
 */
export interface AccountImageResponse {
    /**
     * 
     * @type {string}
     * @memberof AccountImageResponse
     */
    profileImage: string;
}
/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    streetNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    zip?: string;
}
/**
 * 
 * @export
 * @interface ChangeAccount
 */
export interface ChangeAccount {
    /**
     * 
     * @type {string}
     * @memberof ChangeAccount
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeAccount
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeAccount
     */
    dateOfBirth: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeAccount
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeAccount
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeAccount
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeAccount
     */
    salutation: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeAccount
     */
    street: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeAccount
     */
    streetNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeAccount
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeAccount
     */
    zip: string;
    /**
     * The addresses of the related members (linked with the provided relationIds) are changed as well
     * @type {Array<string>}
     * @memberof ChangeAccount
     */
    changeAddressRelations?: Array<string>;
}
/**
 * 
 * @export
 * @interface ChangeAccountImage
 */
export interface ChangeAccountImage {
    /**
     * 
     * @type {string}
     * @memberof ChangeAccountImage
     */
    profileImage: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeAccountImage
     */
    profileImageLarge?: string;
}
/**
 * 
 * @export
 * @interface ChangeAccountMembership
 */
export interface ChangeAccountMembership {
    /**
     * The PNR identifying the user as a member
     * @type {number}
     * @memberof ChangeAccountMembership
     */
    cknr: number;
    /**
     * 
     * @type {string}
     * @memberof ChangeAccountMembership
     */
    zip: string;
}
/**
 * 
 * @export
 * @interface ChangePassword
 */
export interface ChangePassword {
    /**
     * 
     * @type {string}
     * @memberof ChangePassword
     */
    newPassword: string;
    /**
     * 
     * @type {string}
     * @memberof ChangePassword
     */
    oldPassword: string;
}
/**
 * 
 * @export
 * @interface ChangeRegistration
 */
export interface ChangeRegistration {
    /**
     * 
     * @type {string}
     * @memberof ChangeRegistration
     */
    password?: string;
}
/**
 * 
 * @export
 * @interface CompleteRegistrationResponse
 */
export interface CompleteRegistrationResponse {
    /**
     * 
     * @type {string}
     * @memberof CompleteRegistrationResponse
     */
    identityKey: string;
    /**
     * 
     * @type {string}
     * @memberof CompleteRegistrationResponse
     */
    ssoid?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CompleteRegistrationResponse
     */
    pwdRequired?: boolean;
}
/**
 * 
 * @export
 * @interface Country
 */
export interface Country {
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    value?: string;
}
/**
 * 
 * @export
 * @interface DeleteAccount
 */
export interface DeleteAccount {
    /**
     * 
     * @type {string}
     * @memberof DeleteAccount
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteAccount
     */
    reason?: string;
}
/**
 * 
 * @export
 * @interface Email
 */
export interface Email {
    /**
     * 
     * @type {string}
     * @memberof Email
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof Email
     */
    status?: EmailStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof Email
     */
    inChange?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Email
     */
    emailInChange?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum EmailStatusEnum {
    Unconfirmed = 'unconfirmed',
    Confirmed = 'confirmed'
}

/**
 * 
 * @export
 * @interface EmailAddress
 */
export interface EmailAddress {
    /**
     * 
     * @type {string}
     * @memberof EmailAddress
     */
    email: string;
}
/**
 * 
 * @export
 * @interface EmailChange
 */
export interface EmailChange {
    /**
     * 
     * @type {string}
     * @memberof EmailChange
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailChange
     */
    changeToken?: string;
}
/**
 * 
 * @export
 * @interface EmailValidation
 */
export interface EmailValidation {
    /**
     * 
     * @type {boolean}
     * @memberof EmailValidation
     */
    valid?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EmailValidation
     */
    available?: boolean;
}
/**
 * 
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponse
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    message?: string;
    /**
     * 
     * @type {Array<Error>}
     * @memberof ErrorResponse
     */
    errors?: Array<Error>;
}
/**
 * 
 * @export
 * @interface IdentityResponse
 */
export interface IdentityResponse {
    /**
     * 
     * @type {string}
     * @memberof IdentityResponse
     */
    identityKey?: string;
    /**
     * 
     * @type {number}
     * @memberof IdentityResponse
     */
    cknr?: number;
    /**
     * 
     * @type {string}
     * @memberof IdentityResponse
     */
    email?: string;
    /**
     * 
     * @type {number}
     * @memberof IdentityResponse
     */
    userId?: number;
}
/**
 * 
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    value?: string;
}
/**
 * 
 * @export
 * @interface NewEmail
 */
export interface NewEmail {
    /**
     * 
     * @type {string}
     * @memberof NewEmail
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof NewEmail
     */
    status?: NewEmailStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum NewEmailStatusEnum {
    Unconfirmed = 'unconfirmed',
    Confirmed = 'confirmed'
}

/**
 * 
 * @export
 * @interface NewRegistration
 */
export interface NewRegistration {
    /**
     * 
     * @type {string}
     * @memberof NewRegistration
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof NewRegistration
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof NewRegistration
     */
    salutation?: string;
    /**
     * 
     * @type {string}
     * @memberof NewRegistration
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof NewRegistration
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof NewRegistration
     */
    lastName?: string;
    /**
     * The PNR identifying the user as a member
     * @type {number}
     * @memberof NewRegistration
     */
    cknr?: number;
    /**
     * 
     * @type {string}
     * @memberof NewRegistration
     */
    zip?: string;
}
/**
 * 
 * @export
 * @interface PasswordResetResponse
 */
export interface PasswordResetResponse {
    /**
     * 
     * @type {boolean}
     * @memberof PasswordResetResponse
     */
    status: boolean;
}
/**
 * 
 * @export
 * @interface RegistrationData
 */
export interface RegistrationData {
    /**
     * 
     * @type {string}
     * @memberof RegistrationData
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof RegistrationData
     */
    identityKey?: string;
    /**
     * 
     * @type {string}
     * @memberof RegistrationData
     */
    status?: RegistrationDataStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum RegistrationDataStatusEnum {
    Unconfirmed = 'unconfirmed',
    Confirmed = 'confirmed'
}

/**
 * 
 * @export
 * @interface ResetPasswordData
 */
export interface ResetPasswordData {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordData
     */
    newPassword: string;
}
/**
 * 
 * @export
 * @interface SecretResponse
 */
export interface SecretResponse {
    /**
     * 
     * @type {string}
     * @memberof SecretResponse
     */
    secret?: string;
}
/**
 * 
 * @export
 * @interface SetPasswordRequest
 */
export interface SetPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof SetPasswordRequest
     */
    password: string;
}
/**
 * 
 * @export
 * @interface SetPasswordResponse
 */
export interface SetPasswordResponse {
    /**
     * 
     * @type {string}
     * @memberof SetPasswordResponse
     */
    ssoid?: string;
}
/**
 * 
 * @export
 * @interface ValidationResponse
 */
export interface ValidationResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ValidationResponse
     */
    success?: boolean;
}

/**
 * MasterdataApi - axios parameter creator
 * @export
 */
export const MasterdataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List all available countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countries: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/masterdata/countries`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all available salutations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salutation: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/masterdata/salutations`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all available titles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        titles: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/masterdata/titles`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MasterdataApi - functional programming interface
 * @export
 */
export const MasterdataApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List all available countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countries(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Country>>> {
            const localVarAxiosArgs = await MasterdataApiAxiosParamCreator(configuration).countries(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary List all available salutations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async salutation(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await MasterdataApiAxiosParamCreator(configuration).salutation(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary List all available titles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async titles(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await MasterdataApiAxiosParamCreator(configuration).titles(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * MasterdataApi - factory interface
 * @export
 */
export const MasterdataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary List all available countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countries(options?: any): AxiosPromise<Array<Country>> {
            return MasterdataApiFp(configuration).countries(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all available salutations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salutation(options?: any): AxiosPromise<Array<string>> {
            return MasterdataApiFp(configuration).salutation(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all available titles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        titles(options?: any): AxiosPromise<Array<string>> {
            return MasterdataApiFp(configuration).titles(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MasterdataApi - object-oriented interface
 * @export
 * @class MasterdataApi
 * @extends {BaseAPI}
 */
export class MasterdataApi extends BaseAPI {
    /**
     * 
     * @summary List all available countries
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterdataApi
     */
    public countries(options?: any) {
        return MasterdataApiFp(this.configuration).countries(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all available salutations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterdataApi
     */
    public salutation(options?: any) {
        return MasterdataApiFp(this.configuration).salutation(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all available titles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterdataApi
     */
    public titles(options?: any) {
        return MasterdataApiFp(this.configuration).titles(options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * MyAccountApi - axios parameter creator
 * @export
 */
export const MyAccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Update users personal data, optionally trigger email change
         * @param {string} oeamtcIdentityKey identity-key
         * @param {ChangeAccount} changePersonalData changePersonalData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePersonalData: async (oeamtcIdentityKey: string, changePersonalData: ChangeAccount, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'oeamtcIdentityKey' is not null or undefined
            if (oeamtcIdentityKey === null || oeamtcIdentityKey === undefined) {
                throw new RequiredError('oeamtcIdentityKey','Required parameter oeamtcIdentityKey was null or undefined when calling changePersonalData.');
            }
            // verify required parameter 'changePersonalData' is not null or undefined
            if (changePersonalData === null || changePersonalData === undefined) {
                throw new RequiredError('changePersonalData','Required parameter changePersonalData was null or undefined when calling changePersonalData.');
            }
            const localVarPath = `/account`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof changePersonalData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(changePersonalData !== undefined ? changePersonalData : {}) : (changePersonalData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change profile image
         * @param {string} oeamtcIdentityKey identity-key
         * @param {ChangeAccountImage} changeProfileImage changeProfileImage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeProfileImage: async (oeamtcIdentityKey: string, changeProfileImage: ChangeAccountImage, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'oeamtcIdentityKey' is not null or undefined
            if (oeamtcIdentityKey === null || oeamtcIdentityKey === undefined) {
                throw new RequiredError('oeamtcIdentityKey','Required parameter oeamtcIdentityKey was null or undefined when calling changeProfileImage.');
            }
            // verify required parameter 'changeProfileImage' is not null or undefined
            if (changeProfileImage === null || changeProfileImage === undefined) {
                throw new RequiredError('changeProfileImage','Required parameter changeProfileImage was null or undefined when calling changeProfileImage.');
            }
            const localVarPath = `/account/image`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof changeProfileImage !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(changeProfileImage !== undefined ? changeProfileImage : {}) : (changeProfileImage || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete user account
         * @param {string} oeamtcIdentityKey 
         * @param {DeleteAccount} body user password for verification and reason of deleting the account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount: async (oeamtcIdentityKey: string, body: DeleteAccount, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'oeamtcIdentityKey' is not null or undefined
            if (oeamtcIdentityKey === null || oeamtcIdentityKey === undefined) {
                throw new RequiredError('oeamtcIdentityKey','Required parameter oeamtcIdentityKey was null or undefined when calling deleteAccount.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling deleteAccount.');
            }
            const localVarPath = `/account`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete profile image
         * @param {string} oeamtcIdentityKey identity-key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProfileImage: async (oeamtcIdentityKey: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'oeamtcIdentityKey' is not null or undefined
            if (oeamtcIdentityKey === null || oeamtcIdentityKey === undefined) {
                throw new RequiredError('oeamtcIdentityKey','Required parameter oeamtcIdentityKey was null or undefined when calling deleteProfileImage.');
            }
            const localVarPath = `/account/image`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Show information about the user
         * @param {string} [oeamtcIdentityKey] Provide either oeamtc-identity-key or oeamtc-identity-cknr. If both are supplied, oeamtc-identity-key is used.
         * @param {string} [oeamtcIdentityCknr] Provide either oeamtc-identity-key or oeamtc-identity-cknr. If both are supplied, oeamtc-identity-key is used.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountInformation: async (oeamtcIdentityKey?: string, oeamtcIdentityCknr?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/account`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityCknr !== undefined && oeamtcIdentityCknr !== null) {
                localVarHeaderParameter['oeamtc-identity-cknr'] = String(oeamtcIdentityCknr);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns identity information for identityKey/cknr
         * @param {string} oeamtcIdentityKey 
         * @param {string} [oeamtcIdentityCknr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdentity: async (oeamtcIdentityKey: string, oeamtcIdentityCknr?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'oeamtcIdentityKey' is not null or undefined
            if (oeamtcIdentityKey === null || oeamtcIdentityKey === undefined) {
                throw new RequiredError('oeamtcIdentityKey','Required parameter oeamtcIdentityKey was null or undefined when calling getIdentity.');
            }
            const localVarPath = `/identity`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityCknr !== undefined && oeamtcIdentityCknr !== null) {
                localVarHeaderParameter['oeamtc-identity-cknr'] = String(oeamtcIdentityCknr);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the original profile image in base64
         * @param {string} oeamtcIdentityKey identity-key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOriginalProfileImage: async (oeamtcIdentityKey: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'oeamtcIdentityKey' is not null or undefined
            if (oeamtcIdentityKey === null || oeamtcIdentityKey === undefined) {
                throw new RequiredError('oeamtcIdentityKey','Required parameter oeamtcIdentityKey was null or undefined when calling getOriginalProfileImage.');
            }
            const localVarPath = `/account/image/original`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the cropped profile image in base64
         * @param {string} oeamtcIdentityKey identity-key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileImage: async (oeamtcIdentityKey: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'oeamtcIdentityKey' is not null or undefined
            if (oeamtcIdentityKey === null || oeamtcIdentityKey === undefined) {
                throw new RequiredError('oeamtcIdentityKey','Required parameter oeamtcIdentityKey was null or undefined when calling getProfileImage.');
            }
            const localVarPath = `/account/image`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the secret of a user using identityKey or cknr
         * @param {string} oeamtcIdentityKey 
         * @param {string} [oeamtcIdentityCknr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecret: async (oeamtcIdentityKey: string, oeamtcIdentityCknr?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'oeamtcIdentityKey' is not null or undefined
            if (oeamtcIdentityKey === null || oeamtcIdentityKey === undefined) {
                throw new RequiredError('oeamtcIdentityKey','Required parameter oeamtcIdentityKey was null or undefined when calling getSecret.');
            }
            const localVarPath = `/secret`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }

            if (oeamtcIdentityCknr !== undefined && oeamtcIdentityCknr !== null) {
                localVarHeaderParameter['oeamtc-identity-cknr'] = String(oeamtcIdentityCknr);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Can be used to link online account with existing membership.
         * @summary Change user account
         * @param {string} oeamtcIdentityKey identity-key
         * @param {ChangeAccountMembership} accountChange accountChange
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccount: async (oeamtcIdentityKey: string, accountChange: ChangeAccountMembership, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'oeamtcIdentityKey' is not null or undefined
            if (oeamtcIdentityKey === null || oeamtcIdentityKey === undefined) {
                throw new RequiredError('oeamtcIdentityKey','Required parameter oeamtcIdentityKey was null or undefined when calling updateAccount.');
            }
            // verify required parameter 'accountChange' is not null or undefined
            if (accountChange === null || accountChange === undefined) {
                throw new RequiredError('accountChange','Required parameter accountChange was null or undefined when calling updateAccount.');
            }
            const localVarPath = `/account/membership`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof accountChange !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(accountChange !== undefined ? accountChange : {}) : (accountChange || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MyAccountApi - functional programming interface
 * @export
 */
export const MyAccountApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Update users personal data, optionally trigger email change
         * @param {string} oeamtcIdentityKey identity-key
         * @param {ChangeAccount} changePersonalData changePersonalData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePersonalData(oeamtcIdentityKey: string, changePersonalData: ChangeAccount, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await MyAccountApiAxiosParamCreator(configuration).changePersonalData(oeamtcIdentityKey, changePersonalData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Change profile image
         * @param {string} oeamtcIdentityKey identity-key
         * @param {ChangeAccountImage} changeProfileImage changeProfileImage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeProfileImage(oeamtcIdentityKey: string, changeProfileImage: ChangeAccountImage, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await MyAccountApiAxiosParamCreator(configuration).changeProfileImage(oeamtcIdentityKey, changeProfileImage, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * delete user account
         * @param {string} oeamtcIdentityKey 
         * @param {DeleteAccount} body user password for verification and reason of deleting the account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAccount(oeamtcIdentityKey: string, body: DeleteAccount, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await MyAccountApiAxiosParamCreator(configuration).deleteAccount(oeamtcIdentityKey, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Delete profile image
         * @param {string} oeamtcIdentityKey identity-key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProfileImage(oeamtcIdentityKey: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await MyAccountApiAxiosParamCreator(configuration).deleteProfileImage(oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Show information about the user
         * @param {string} [oeamtcIdentityKey] Provide either oeamtc-identity-key or oeamtc-identity-cknr. If both are supplied, oeamtc-identity-key is used.
         * @param {string} [oeamtcIdentityCknr] Provide either oeamtc-identity-key or oeamtc-identity-cknr. If both are supplied, oeamtc-identity-key is used.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountInformation(oeamtcIdentityKey?: string, oeamtcIdentityCknr?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Account>> {
            const localVarAxiosArgs = await MyAccountApiAxiosParamCreator(configuration).getAccountInformation(oeamtcIdentityKey, oeamtcIdentityCknr, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns identity information for identityKey/cknr
         * @param {string} oeamtcIdentityKey 
         * @param {string} [oeamtcIdentityCknr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIdentity(oeamtcIdentityKey: string, oeamtcIdentityCknr?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityResponse>> {
            const localVarAxiosArgs = await MyAccountApiAxiosParamCreator(configuration).getIdentity(oeamtcIdentityKey, oeamtcIdentityCknr, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns the original profile image in base64
         * @param {string} oeamtcIdentityKey identity-key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOriginalProfileImage(oeamtcIdentityKey: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountImageResponse>> {
            const localVarAxiosArgs = await MyAccountApiAxiosParamCreator(configuration).getOriginalProfileImage(oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns the cropped profile image in base64
         * @param {string} oeamtcIdentityKey identity-key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfileImage(oeamtcIdentityKey: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountImageResponse>> {
            const localVarAxiosArgs = await MyAccountApiAxiosParamCreator(configuration).getProfileImage(oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get the secret of a user using identityKey or cknr
         * @param {string} oeamtcIdentityKey 
         * @param {string} [oeamtcIdentityCknr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSecret(oeamtcIdentityKey: string, oeamtcIdentityCknr?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SecretResponse>> {
            const localVarAxiosArgs = await MyAccountApiAxiosParamCreator(configuration).getSecret(oeamtcIdentityKey, oeamtcIdentityCknr, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Can be used to link online account with existing membership.
         * @summary Change user account
         * @param {string} oeamtcIdentityKey identity-key
         * @param {ChangeAccountMembership} accountChange accountChange
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAccount(oeamtcIdentityKey: string, accountChange: ChangeAccountMembership, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await MyAccountApiAxiosParamCreator(configuration).updateAccount(oeamtcIdentityKey, accountChange, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * MyAccountApi - factory interface
 * @export
 */
export const MyAccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Update users personal data, optionally trigger email change
         * @param {string} oeamtcIdentityKey identity-key
         * @param {ChangeAccount} changePersonalData changePersonalData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePersonalData(oeamtcIdentityKey: string, changePersonalData: ChangeAccount, options?: any): AxiosPromise<void> {
            return MyAccountApiFp(configuration).changePersonalData(oeamtcIdentityKey, changePersonalData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change profile image
         * @param {string} oeamtcIdentityKey identity-key
         * @param {ChangeAccountImage} changeProfileImage changeProfileImage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeProfileImage(oeamtcIdentityKey: string, changeProfileImage: ChangeAccountImage, options?: any): AxiosPromise<void> {
            return MyAccountApiFp(configuration).changeProfileImage(oeamtcIdentityKey, changeProfileImage, options).then((request) => request(axios, basePath));
        },
        /**
         * delete user account
         * @param {string} oeamtcIdentityKey 
         * @param {DeleteAccount} body user password for verification and reason of deleting the account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount(oeamtcIdentityKey: string, body: DeleteAccount, options?: any): AxiosPromise<void> {
            return MyAccountApiFp(configuration).deleteAccount(oeamtcIdentityKey, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete profile image
         * @param {string} oeamtcIdentityKey identity-key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProfileImage(oeamtcIdentityKey: string, options?: any): AxiosPromise<void> {
            return MyAccountApiFp(configuration).deleteProfileImage(oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Show information about the user
         * @param {string} [oeamtcIdentityKey] Provide either oeamtc-identity-key or oeamtc-identity-cknr. If both are supplied, oeamtc-identity-key is used.
         * @param {string} [oeamtcIdentityCknr] Provide either oeamtc-identity-key or oeamtc-identity-cknr. If both are supplied, oeamtc-identity-key is used.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountInformation(oeamtcIdentityKey?: string, oeamtcIdentityCknr?: string, options?: any): AxiosPromise<Account> {
            return MyAccountApiFp(configuration).getAccountInformation(oeamtcIdentityKey, oeamtcIdentityCknr, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns identity information for identityKey/cknr
         * @param {string} oeamtcIdentityKey 
         * @param {string} [oeamtcIdentityCknr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdentity(oeamtcIdentityKey: string, oeamtcIdentityCknr?: string, options?: any): AxiosPromise<IdentityResponse> {
            return MyAccountApiFp(configuration).getIdentity(oeamtcIdentityKey, oeamtcIdentityCknr, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the original profile image in base64
         * @param {string} oeamtcIdentityKey identity-key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOriginalProfileImage(oeamtcIdentityKey: string, options?: any): AxiosPromise<AccountImageResponse> {
            return MyAccountApiFp(configuration).getOriginalProfileImage(oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the cropped profile image in base64
         * @param {string} oeamtcIdentityKey identity-key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileImage(oeamtcIdentityKey: string, options?: any): AxiosPromise<AccountImageResponse> {
            return MyAccountApiFp(configuration).getProfileImage(oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the secret of a user using identityKey or cknr
         * @param {string} oeamtcIdentityKey 
         * @param {string} [oeamtcIdentityCknr] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecret(oeamtcIdentityKey: string, oeamtcIdentityCknr?: string, options?: any): AxiosPromise<SecretResponse> {
            return MyAccountApiFp(configuration).getSecret(oeamtcIdentityKey, oeamtcIdentityCknr, options).then((request) => request(axios, basePath));
        },
        /**
         * Can be used to link online account with existing membership.
         * @summary Change user account
         * @param {string} oeamtcIdentityKey identity-key
         * @param {ChangeAccountMembership} accountChange accountChange
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccount(oeamtcIdentityKey: string, accountChange: ChangeAccountMembership, options?: any): AxiosPromise<void> {
            return MyAccountApiFp(configuration).updateAccount(oeamtcIdentityKey, accountChange, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MyAccountApi - object-oriented interface
 * @export
 * @class MyAccountApi
 * @extends {BaseAPI}
 */
export class MyAccountApi extends BaseAPI {
    /**
     * 
     * @summary Update users personal data, optionally trigger email change
     * @param {string} oeamtcIdentityKey identity-key
     * @param {ChangeAccount} changePersonalData changePersonalData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyAccountApi
     */
    public changePersonalData(oeamtcIdentityKey: string, changePersonalData: ChangeAccount, options?: any) {
        return MyAccountApiFp(this.configuration).changePersonalData(oeamtcIdentityKey, changePersonalData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change profile image
     * @param {string} oeamtcIdentityKey identity-key
     * @param {ChangeAccountImage} changeProfileImage changeProfileImage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyAccountApi
     */
    public changeProfileImage(oeamtcIdentityKey: string, changeProfileImage: ChangeAccountImage, options?: any) {
        return MyAccountApiFp(this.configuration).changeProfileImage(oeamtcIdentityKey, changeProfileImage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete user account
     * @param {string} oeamtcIdentityKey 
     * @param {DeleteAccount} body user password for verification and reason of deleting the account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyAccountApi
     */
    public deleteAccount(oeamtcIdentityKey: string, body: DeleteAccount, options?: any) {
        return MyAccountApiFp(this.configuration).deleteAccount(oeamtcIdentityKey, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete profile image
     * @param {string} oeamtcIdentityKey identity-key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyAccountApi
     */
    public deleteProfileImage(oeamtcIdentityKey: string, options?: any) {
        return MyAccountApiFp(this.configuration).deleteProfileImage(oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Show information about the user
     * @param {string} [oeamtcIdentityKey] Provide either oeamtc-identity-key or oeamtc-identity-cknr. If both are supplied, oeamtc-identity-key is used.
     * @param {string} [oeamtcIdentityCknr] Provide either oeamtc-identity-key or oeamtc-identity-cknr. If both are supplied, oeamtc-identity-key is used.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyAccountApi
     */
    public getAccountInformation(oeamtcIdentityKey?: string, oeamtcIdentityCknr?: string, options?: any) {
        return MyAccountApiFp(this.configuration).getAccountInformation(oeamtcIdentityKey, oeamtcIdentityCknr, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns identity information for identityKey/cknr
     * @param {string} oeamtcIdentityKey 
     * @param {string} [oeamtcIdentityCknr] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyAccountApi
     */
    public getIdentity(oeamtcIdentityKey: string, oeamtcIdentityCknr?: string, options?: any) {
        return MyAccountApiFp(this.configuration).getIdentity(oeamtcIdentityKey, oeamtcIdentityCknr, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the original profile image in base64
     * @param {string} oeamtcIdentityKey identity-key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyAccountApi
     */
    public getOriginalProfileImage(oeamtcIdentityKey: string, options?: any) {
        return MyAccountApiFp(this.configuration).getOriginalProfileImage(oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the cropped profile image in base64
     * @param {string} oeamtcIdentityKey identity-key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyAccountApi
     */
    public getProfileImage(oeamtcIdentityKey: string, options?: any) {
        return MyAccountApiFp(this.configuration).getProfileImage(oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the secret of a user using identityKey or cknr
     * @param {string} oeamtcIdentityKey 
     * @param {string} [oeamtcIdentityCknr] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyAccountApi
     */
    public getSecret(oeamtcIdentityKey: string, oeamtcIdentityCknr?: string, options?: any) {
        return MyAccountApiFp(this.configuration).getSecret(oeamtcIdentityKey, oeamtcIdentityCknr, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Can be used to link online account with existing membership.
     * @summary Change user account
     * @param {string} oeamtcIdentityKey identity-key
     * @param {ChangeAccountMembership} accountChange accountChange
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyAccountApi
     */
    public updateAccount(oeamtcIdentityKey: string, accountChange: ChangeAccountMembership, options?: any) {
        return MyAccountApiFp(this.configuration).updateAccount(oeamtcIdentityKey, accountChange, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * MyEmailApi - axios parameter creator
 * @export
 */
export const MyEmailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Cancel email change
         * @param {string} changeToken Token of change mail request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelEmailChange: async (changeToken: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'changeToken' is not null or undefined
            if (changeToken === null || changeToken === undefined) {
                throw new RequiredError('changeToken','Required parameter changeToken was null or undefined when calling cancelEmailChange.');
            }
            const localVarPath = `/email/changes/{changeToken}`
                .replace(`{${"changeToken"}}`, encodeURIComponent(String(changeToken)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use Case #1: Initiate email change - Precondition: no ongoing email change process - Change *email*, keep current status - Send verification mail for email change  Use Case #2: Initiate email validation - Precondition no on-going email validation process - Change *status* to *unconfirmed*, keep current mail - Send verification mail  Use Case #3: Resume email change / validation - Precondition: ongoing email change or email validation process - Initiate email change or validation process again. - Backend should check that there is an ongoing processes - Backend should either resend mail with current token or cancel the ongoing process, generate a new token and herewith start a new process  Use Case #4: Restart email change / validation - Precondition: ongoing email change or email validation process - Cancel ongoing change process - Start use case #1 or #2  Return \"400 Bad Request\" if: - current status == \"unconfirmed\" and \"confirmed\" is provided - both \"email\" and \"status\" are changed 
         * @summary Initiate email change
         * @param {string} oeamtcIdentityKey identity-key
         * @param {NewEmail} newEmail newEmail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeEmail: async (oeamtcIdentityKey: string, newEmail: NewEmail, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'oeamtcIdentityKey' is not null or undefined
            if (oeamtcIdentityKey === null || oeamtcIdentityKey === undefined) {
                throw new RequiredError('oeamtcIdentityKey','Required parameter oeamtcIdentityKey was null or undefined when calling changeEmail.');
            }
            // verify required parameter 'newEmail' is not null or undefined
            if (newEmail === null || newEmail === undefined) {
                throw new RequiredError('newEmail','Required parameter newEmail was null or undefined when calling changeEmail.');
            }
            const localVarPath = `/email/changes`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json;charset=UTF-8';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof newEmail !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(newEmail !== undefined ? newEmail : {}) : (newEmail || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Complete email change
         * @param {string} changeToken Token of change mail request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeEmailChange: async (changeToken: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'changeToken' is not null or undefined
            if (changeToken === null || changeToken === undefined) {
                throw new RequiredError('changeToken','Required parameter changeToken was null or undefined when calling completeEmailChange.');
            }
            const localVarPath = `/email/changes/{changeToken}`
                .replace(`{${"changeToken"}}`, encodeURIComponent(String(changeToken)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Show information about email
         * @param {string} oeamtcIdentityKey identity-key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailInformation: async (oeamtcIdentityKey: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'oeamtcIdentityKey' is not null or undefined
            if (oeamtcIdentityKey === null || oeamtcIdentityKey === undefined) {
                throw new RequiredError('oeamtcIdentityKey','Required parameter oeamtcIdentityKey was null or undefined when calling getEmailInformation.');
            }
            const localVarPath = `/email`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MyEmailApi - functional programming interface
 * @export
 */
export const MyEmailApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Cancel email change
         * @param {string} changeToken Token of change mail request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelEmailChange(changeToken: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await MyEmailApiAxiosParamCreator(configuration).cancelEmailChange(changeToken, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Use Case #1: Initiate email change - Precondition: no ongoing email change process - Change *email*, keep current status - Send verification mail for email change  Use Case #2: Initiate email validation - Precondition no on-going email validation process - Change *status* to *unconfirmed*, keep current mail - Send verification mail  Use Case #3: Resume email change / validation - Precondition: ongoing email change or email validation process - Initiate email change or validation process again. - Backend should check that there is an ongoing processes - Backend should either resend mail with current token or cancel the ongoing process, generate a new token and herewith start a new process  Use Case #4: Restart email change / validation - Precondition: ongoing email change or email validation process - Cancel ongoing change process - Start use case #1 or #2  Return \"400 Bad Request\" if: - current status == \"unconfirmed\" and \"confirmed\" is provided - both \"email\" and \"status\" are changed 
         * @summary Initiate email change
         * @param {string} oeamtcIdentityKey identity-key
         * @param {NewEmail} newEmail newEmail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeEmail(oeamtcIdentityKey: string, newEmail: NewEmail, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailChange>> {
            const localVarAxiosArgs = await MyEmailApiAxiosParamCreator(configuration).changeEmail(oeamtcIdentityKey, newEmail, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Complete email change
         * @param {string} changeToken Token of change mail request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeEmailChange(changeToken: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await MyEmailApiAxiosParamCreator(configuration).completeEmailChange(changeToken, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Show information about email
         * @param {string} oeamtcIdentityKey identity-key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmailInformation(oeamtcIdentityKey: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Email>> {
            const localVarAxiosArgs = await MyEmailApiAxiosParamCreator(configuration).getEmailInformation(oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * MyEmailApi - factory interface
 * @export
 */
export const MyEmailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Cancel email change
         * @param {string} changeToken Token of change mail request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelEmailChange(changeToken: string, options?: any): AxiosPromise<void> {
            return MyEmailApiFp(configuration).cancelEmailChange(changeToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Use Case #1: Initiate email change - Precondition: no ongoing email change process - Change *email*, keep current status - Send verification mail for email change  Use Case #2: Initiate email validation - Precondition no on-going email validation process - Change *status* to *unconfirmed*, keep current mail - Send verification mail  Use Case #3: Resume email change / validation - Precondition: ongoing email change or email validation process - Initiate email change or validation process again. - Backend should check that there is an ongoing processes - Backend should either resend mail with current token or cancel the ongoing process, generate a new token and herewith start a new process  Use Case #4: Restart email change / validation - Precondition: ongoing email change or email validation process - Cancel ongoing change process - Start use case #1 or #2  Return \"400 Bad Request\" if: - current status == \"unconfirmed\" and \"confirmed\" is provided - both \"email\" and \"status\" are changed 
         * @summary Initiate email change
         * @param {string} oeamtcIdentityKey identity-key
         * @param {NewEmail} newEmail newEmail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeEmail(oeamtcIdentityKey: string, newEmail: NewEmail, options?: any): AxiosPromise<EmailChange> {
            return MyEmailApiFp(configuration).changeEmail(oeamtcIdentityKey, newEmail, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Complete email change
         * @param {string} changeToken Token of change mail request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeEmailChange(changeToken: string, options?: any): AxiosPromise<void> {
            return MyEmailApiFp(configuration).completeEmailChange(changeToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Show information about email
         * @param {string} oeamtcIdentityKey identity-key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailInformation(oeamtcIdentityKey: string, options?: any): AxiosPromise<Email> {
            return MyEmailApiFp(configuration).getEmailInformation(oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MyEmailApi - object-oriented interface
 * @export
 * @class MyEmailApi
 * @extends {BaseAPI}
 */
export class MyEmailApi extends BaseAPI {
    /**
     * 
     * @summary Cancel email change
     * @param {string} changeToken Token of change mail request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyEmailApi
     */
    public cancelEmailChange(changeToken: string, options?: any) {
        return MyEmailApiFp(this.configuration).cancelEmailChange(changeToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use Case #1: Initiate email change - Precondition: no ongoing email change process - Change *email*, keep current status - Send verification mail for email change  Use Case #2: Initiate email validation - Precondition no on-going email validation process - Change *status* to *unconfirmed*, keep current mail - Send verification mail  Use Case #3: Resume email change / validation - Precondition: ongoing email change or email validation process - Initiate email change or validation process again. - Backend should check that there is an ongoing processes - Backend should either resend mail with current token or cancel the ongoing process, generate a new token and herewith start a new process  Use Case #4: Restart email change / validation - Precondition: ongoing email change or email validation process - Cancel ongoing change process - Start use case #1 or #2  Return \"400 Bad Request\" if: - current status == \"unconfirmed\" and \"confirmed\" is provided - both \"email\" and \"status\" are changed 
     * @summary Initiate email change
     * @param {string} oeamtcIdentityKey identity-key
     * @param {NewEmail} newEmail newEmail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyEmailApi
     */
    public changeEmail(oeamtcIdentityKey: string, newEmail: NewEmail, options?: any) {
        return MyEmailApiFp(this.configuration).changeEmail(oeamtcIdentityKey, newEmail, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Complete email change
     * @param {string} changeToken Token of change mail request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyEmailApi
     */
    public completeEmailChange(changeToken: string, options?: any) {
        return MyEmailApiFp(this.configuration).completeEmailChange(changeToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Show information about email
     * @param {string} oeamtcIdentityKey identity-key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyEmailApi
     */
    public getEmailInformation(oeamtcIdentityKey: string, options?: any) {
        return MyEmailApiFp(this.configuration).getEmailInformation(oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * MyPasswordApi - axios parameter creator
 * @export
 */
export const MyPasswordApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Change user password
         * @param {string} oeamtcIdentityKey identity-key
         * @param {ChangePassword} changePassword changePassword
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword: async (oeamtcIdentityKey: string, changePassword: ChangePassword, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'oeamtcIdentityKey' is not null or undefined
            if (oeamtcIdentityKey === null || oeamtcIdentityKey === undefined) {
                throw new RequiredError('oeamtcIdentityKey','Required parameter oeamtcIdentityKey was null or undefined when calling changePassword.');
            }
            // verify required parameter 'changePassword' is not null or undefined
            if (changePassword === null || changePassword === undefined) {
                throw new RequiredError('changePassword','Required parameter changePassword was null or undefined when calling changePassword.');
            }
            const localVarPath = `/password`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json;charset=UTF-8';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof changePassword !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(changePassword !== undefined ? changePassword : {}) : (changePassword || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Complete password reset
         * @param {string} resetToken Token of password reset request
         * @param {ResetPasswordData} resetPasswordData reset password data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completePasswordReset: async (resetToken: string, resetPasswordData: ResetPasswordData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetToken' is not null or undefined
            if (resetToken === null || resetToken === undefined) {
                throw new RequiredError('resetToken','Required parameter resetToken was null or undefined when calling completePasswordReset.');
            }
            // verify required parameter 'resetPasswordData' is not null or undefined
            if (resetPasswordData === null || resetPasswordData === undefined) {
                throw new RequiredError('resetPasswordData','Required parameter resetPasswordData was null or undefined when calling completePasswordReset.');
            }
            const localVarPath = `/password/reset/{resetToken}`
                .replace(`{${"resetToken"}}`, encodeURIComponent(String(resetToken)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof resetPasswordData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(resetPasswordData !== undefined ? resetPasswordData : {}) : (resetPasswordData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Show information about password reset
         * @param {string} resetToken Token of password reset request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPasswordReset: async (resetToken: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetToken' is not null or undefined
            if (resetToken === null || resetToken === undefined) {
                throw new RequiredError('resetToken','Required parameter resetToken was null or undefined when calling getPasswordReset.');
            }
            const localVarPath = `/password/reset/{resetToken}`
                .replace(`{${"resetToken"}}`, encodeURIComponent(String(resetToken)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Initiate password reset by sending email
         * @summary Initiate password reset
         * @param {EmailAddress} emailAddress The email address to initialize the password reset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiatePasswordReset: async (emailAddress: EmailAddress, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailAddress' is not null or undefined
            if (emailAddress === null || emailAddress === undefined) {
                throw new RequiredError('emailAddress','Required parameter emailAddress was null or undefined when calling initiatePasswordReset.');
            }
            const localVarPath = `/password/reset`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json;charset=UTF-8';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof emailAddress !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(emailAddress !== undefined ? emailAddress : {}) : (emailAddress || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MyPasswordApi - functional programming interface
 * @export
 */
export const MyPasswordApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Change user password
         * @param {string} oeamtcIdentityKey identity-key
         * @param {ChangePassword} changePassword changePassword
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePassword(oeamtcIdentityKey: string, changePassword: ChangePassword, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await MyPasswordApiAxiosParamCreator(configuration).changePassword(oeamtcIdentityKey, changePassword, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Complete password reset
         * @param {string} resetToken Token of password reset request
         * @param {ResetPasswordData} resetPasswordData reset password data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completePasswordReset(resetToken: string, resetPasswordData: ResetPasswordData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await MyPasswordApiAxiosParamCreator(configuration).completePasswordReset(resetToken, resetPasswordData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Show information about password reset
         * @param {string} resetToken Token of password reset request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPasswordReset(resetToken: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PasswordResetResponse>> {
            const localVarAxiosArgs = await MyPasswordApiAxiosParamCreator(configuration).getPasswordReset(resetToken, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Initiate password reset by sending email
         * @summary Initiate password reset
         * @param {EmailAddress} emailAddress The email address to initialize the password reset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initiatePasswordReset(emailAddress: EmailAddress, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await MyPasswordApiAxiosParamCreator(configuration).initiatePasswordReset(emailAddress, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * MyPasswordApi - factory interface
 * @export
 */
export const MyPasswordApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Change user password
         * @param {string} oeamtcIdentityKey identity-key
         * @param {ChangePassword} changePassword changePassword
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(oeamtcIdentityKey: string, changePassword: ChangePassword, options?: any): AxiosPromise<void> {
            return MyPasswordApiFp(configuration).changePassword(oeamtcIdentityKey, changePassword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Complete password reset
         * @param {string} resetToken Token of password reset request
         * @param {ResetPasswordData} resetPasswordData reset password data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completePasswordReset(resetToken: string, resetPasswordData: ResetPasswordData, options?: any): AxiosPromise<void> {
            return MyPasswordApiFp(configuration).completePasswordReset(resetToken, resetPasswordData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Show information about password reset
         * @param {string} resetToken Token of password reset request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPasswordReset(resetToken: string, options?: any): AxiosPromise<PasswordResetResponse> {
            return MyPasswordApiFp(configuration).getPasswordReset(resetToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Initiate password reset by sending email
         * @summary Initiate password reset
         * @param {EmailAddress} emailAddress The email address to initialize the password reset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiatePasswordReset(emailAddress: EmailAddress, options?: any): AxiosPromise<void> {
            return MyPasswordApiFp(configuration).initiatePasswordReset(emailAddress, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MyPasswordApi - object-oriented interface
 * @export
 * @class MyPasswordApi
 * @extends {BaseAPI}
 */
export class MyPasswordApi extends BaseAPI {
    /**
     * 
     * @summary Change user password
     * @param {string} oeamtcIdentityKey identity-key
     * @param {ChangePassword} changePassword changePassword
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyPasswordApi
     */
    public changePassword(oeamtcIdentityKey: string, changePassword: ChangePassword, options?: any) {
        return MyPasswordApiFp(this.configuration).changePassword(oeamtcIdentityKey, changePassword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Complete password reset
     * @param {string} resetToken Token of password reset request
     * @param {ResetPasswordData} resetPasswordData reset password data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyPasswordApi
     */
    public completePasswordReset(resetToken: string, resetPasswordData: ResetPasswordData, options?: any) {
        return MyPasswordApiFp(this.configuration).completePasswordReset(resetToken, resetPasswordData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Show information about password reset
     * @param {string} resetToken Token of password reset request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyPasswordApi
     */
    public getPasswordReset(resetToken: string, options?: any) {
        return MyPasswordApiFp(this.configuration).getPasswordReset(resetToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Initiate password reset by sending email
     * @summary Initiate password reset
     * @param {EmailAddress} emailAddress The email address to initialize the password reset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyPasswordApi
     */
    public initiatePasswordReset(emailAddress: EmailAddress, options?: any) {
        return MyPasswordApiFp(this.configuration).initiatePasswordReset(emailAddress, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * PasswordApi - axios parameter creator
 * @export
 */
export const PasswordApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * set initial password of an user
         * @param {string} registrationToken Token of registration request
         * @param {SetPasswordRequest} body Set initial password of an user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setInitialPassword: async (registrationToken: string, body: SetPasswordRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'registrationToken' is not null or undefined
            if (registrationToken === null || registrationToken === undefined) {
                throw new RequiredError('registrationToken','Required parameter registrationToken was null or undefined when calling setInitialPassword.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling setInitialPassword.');
            }
            const localVarPath = `/password/{registrationToken}`
                .replace(`{${"registrationToken"}}`, encodeURIComponent(String(registrationToken)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PasswordApi - functional programming interface
 * @export
 */
export const PasswordApiFp = function(configuration?: Configuration) {
    return {
        /**
         * set initial password of an user
         * @param {string} registrationToken Token of registration request
         * @param {SetPasswordRequest} body Set initial password of an user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setInitialPassword(registrationToken: string, body: SetPasswordRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SetPasswordResponse>> {
            const localVarAxiosArgs = await PasswordApiAxiosParamCreator(configuration).setInitialPassword(registrationToken, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PasswordApi - factory interface
 * @export
 */
export const PasswordApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * set initial password of an user
         * @param {string} registrationToken Token of registration request
         * @param {SetPasswordRequest} body Set initial password of an user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setInitialPassword(registrationToken: string, body: SetPasswordRequest, options?: any): AxiosPromise<SetPasswordResponse> {
            return PasswordApiFp(configuration).setInitialPassword(registrationToken, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PasswordApi - object-oriented interface
 * @export
 * @class PasswordApi
 * @extends {BaseAPI}
 */
export class PasswordApi extends BaseAPI {
    /**
     * set initial password of an user
     * @param {string} registrationToken Token of registration request
     * @param {SetPasswordRequest} body Set initial password of an user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordApi
     */
    public setInitialPassword(registrationToken: string, body: SetPasswordRequest, options?: any) {
        return PasswordApiFp(this.configuration).setInitialPassword(registrationToken, body, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * PublicApi - axios parameter creator
 * @export
 */
export const PublicApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * - The account is already created - Opt-in mail for registration was sent - Verification of user email - The user has the possibility to not give the password in the first place. Then the password must be provided when completing the registration - Furthermore, the code needs to check if the password was already set 
         * @summary Complete registration
         * @param {string} registrationToken Token of registration request
         * @param {ChangeRegistration} [registrationData] registration data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeRegistration: async (registrationToken: string, registrationData?: ChangeRegistration, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'registrationToken' is not null or undefined
            if (registrationToken === null || registrationToken === undefined) {
                throw new RequiredError('registrationToken','Required parameter registrationToken was null or undefined when calling completeRegistration.');
            }
            const localVarPath = `/registrations/{registrationToken}`
                .replace(`{${"registrationToken"}}`, encodeURIComponent(String(registrationToken)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json;charset=UTF-8';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof registrationData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(registrationData !== undefined ? registrationData : {}) : (registrationData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * - Create an account as non-member or as member - Send opt-in mail for registration 
         * @summary Initiate registration
         * @param {NewRegistration} newRegistration registration data
         * @param {string} [returnUrl] returnUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateRegistration: async (newRegistration: NewRegistration, returnUrl?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'newRegistration' is not null or undefined
            if (newRegistration === null || newRegistration === undefined) {
                throw new RequiredError('newRegistration','Required parameter newRegistration was null or undefined when calling initiateRegistration.');
            }
            const localVarPath = `/registrations`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (returnUrl !== undefined) {
                localVarQueryParameter['returnUrl'] = returnUrl;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json;charset=UTF-8';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof newRegistration !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(newRegistration !== undefined ? newRegistration : {}) : (newRegistration || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * - The account is already created but the mail was lost - Re-send opt-in mail for registration 
         * @summary Resume registration
         * @param {EmailAddress} emailAddress The email address to resume the registration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeRegistration: async (emailAddress: EmailAddress, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailAddress' is not null or undefined
            if (emailAddress === null || emailAddress === undefined) {
                throw new RequiredError('emailAddress','Required parameter emailAddress was null or undefined when calling resumeRegistration.');
            }
            const localVarPath = `/registrations`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof emailAddress !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(emailAddress !== undefined ? emailAddress : {}) : (emailAddress || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicApi - functional programming interface
 * @export
 */
export const PublicApiFp = function(configuration?: Configuration) {
    return {
        /**
         * - The account is already created - Opt-in mail for registration was sent - Verification of user email - The user has the possibility to not give the password in the first place. Then the password must be provided when completing the registration - Furthermore, the code needs to check if the password was already set 
         * @summary Complete registration
         * @param {string} registrationToken Token of registration request
         * @param {ChangeRegistration} [registrationData] registration data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeRegistration(registrationToken: string, registrationData?: ChangeRegistration, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompleteRegistrationResponse>> {
            const localVarAxiosArgs = await PublicApiAxiosParamCreator(configuration).completeRegistration(registrationToken, registrationData, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * - Create an account as non-member or as member - Send opt-in mail for registration 
         * @summary Initiate registration
         * @param {NewRegistration} newRegistration registration data
         * @param {string} [returnUrl] returnUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initiateRegistration(newRegistration: NewRegistration, returnUrl?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegistrationData>> {
            const localVarAxiosArgs = await PublicApiAxiosParamCreator(configuration).initiateRegistration(newRegistration, returnUrl, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * - The account is already created but the mail was lost - Re-send opt-in mail for registration 
         * @summary Resume registration
         * @param {EmailAddress} emailAddress The email address to resume the registration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resumeRegistration(emailAddress: EmailAddress, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegistrationData>> {
            const localVarAxiosArgs = await PublicApiAxiosParamCreator(configuration).resumeRegistration(emailAddress, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PublicApi - factory interface
 * @export
 */
export const PublicApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * - The account is already created - Opt-in mail for registration was sent - Verification of user email - The user has the possibility to not give the password in the first place. Then the password must be provided when completing the registration - Furthermore, the code needs to check if the password was already set 
         * @summary Complete registration
         * @param {string} registrationToken Token of registration request
         * @param {ChangeRegistration} [registrationData] registration data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeRegistration(registrationToken: string, registrationData?: ChangeRegistration, options?: any): AxiosPromise<CompleteRegistrationResponse> {
            return PublicApiFp(configuration).completeRegistration(registrationToken, registrationData, options).then((request) => request(axios, basePath));
        },
        /**
         * - Create an account as non-member or as member - Send opt-in mail for registration 
         * @summary Initiate registration
         * @param {NewRegistration} newRegistration registration data
         * @param {string} [returnUrl] returnUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateRegistration(newRegistration: NewRegistration, returnUrl?: string, options?: any): AxiosPromise<RegistrationData> {
            return PublicApiFp(configuration).initiateRegistration(newRegistration, returnUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * - The account is already created but the mail was lost - Re-send opt-in mail for registration 
         * @summary Resume registration
         * @param {EmailAddress} emailAddress The email address to resume the registration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeRegistration(emailAddress: EmailAddress, options?: any): AxiosPromise<RegistrationData> {
            return PublicApiFp(configuration).resumeRegistration(emailAddress, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PublicApi - object-oriented interface
 * @export
 * @class PublicApi
 * @extends {BaseAPI}
 */
export class PublicApi extends BaseAPI {
    /**
     * - The account is already created - Opt-in mail for registration was sent - Verification of user email - The user has the possibility to not give the password in the first place. Then the password must be provided when completing the registration - Furthermore, the code needs to check if the password was already set 
     * @summary Complete registration
     * @param {string} registrationToken Token of registration request
     * @param {ChangeRegistration} [registrationData] registration data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApi
     */
    public completeRegistration(registrationToken: string, registrationData?: ChangeRegistration, options?: any) {
        return PublicApiFp(this.configuration).completeRegistration(registrationToken, registrationData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * - Create an account as non-member or as member - Send opt-in mail for registration 
     * @summary Initiate registration
     * @param {NewRegistration} newRegistration registration data
     * @param {string} [returnUrl] returnUrl
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApi
     */
    public initiateRegistration(newRegistration: NewRegistration, returnUrl?: string, options?: any) {
        return PublicApiFp(this.configuration).initiateRegistration(newRegistration, returnUrl, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * - The account is already created but the mail was lost - Re-send opt-in mail for registration 
     * @summary Resume registration
     * @param {EmailAddress} emailAddress The email address to resume the registration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApi
     */
    public resumeRegistration(emailAddress: EmailAddress, options?: any) {
        return PublicApiFp(this.configuration).resumeRegistration(emailAddress, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ValidationsApi - axios parameter creator
 * @export
 */
export const ValidationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Validate cknr for its availability in the profile context
         * @param {string} cknr cknr
         * @param {string} zip zip code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCknr: async (cknr: string, zip: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cknr' is not null or undefined
            if (cknr === null || cknr === undefined) {
                throw new RequiredError('cknr','Required parameter cknr was null or undefined when calling validateCknr.');
            }
            // verify required parameter 'zip' is not null or undefined
            if (zip === null || zip === undefined) {
                throw new RequiredError('zip','Required parameter zip was null or undefined when calling validateCknr.');
            }
            const localVarPath = `/validations/cknr`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cknr !== undefined) {
                localVarQueryParameter['cknr'] = cknr;
            }

            if (zip !== undefined) {
                localVarQueryParameter['zip'] = zip;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate email
         * @param {string} email email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateEmail: async (email: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            if (email === null || email === undefined) {
                throw new RequiredError('email','Required parameter email was null or undefined when calling validateEmail.');
            }
            const localVarPath = `/validations/email`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ValidationsApi - functional programming interface
 * @export
 */
export const ValidationsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Validate cknr for its availability in the profile context
         * @param {string} cknr cknr
         * @param {string} zip zip code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateCknr(cknr: string, zip: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidationResponse>> {
            const localVarAxiosArgs = await ValidationsApiAxiosParamCreator(configuration).validateCknr(cknr, zip, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate email
         * @param {string} email email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateEmail(email: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailValidation>> {
            const localVarAxiosArgs = await ValidationsApiAxiosParamCreator(configuration).validateEmail(email, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ValidationsApi - factory interface
 * @export
 */
export const ValidationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Validate cknr for its availability in the profile context
         * @param {string} cknr cknr
         * @param {string} zip zip code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCknr(cknr: string, zip: string, options?: any): AxiosPromise<ValidationResponse> {
            return ValidationsApiFp(configuration).validateCknr(cknr, zip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validate email
         * @param {string} email email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateEmail(email: string, options?: any): AxiosPromise<EmailValidation> {
            return ValidationsApiFp(configuration).validateEmail(email, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ValidationsApi - object-oriented interface
 * @export
 * @class ValidationsApi
 * @extends {BaseAPI}
 */
export class ValidationsApi extends BaseAPI {
    /**
     * 
     * @summary Validate cknr for its availability in the profile context
     * @param {string} cknr cknr
     * @param {string} zip zip code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationsApi
     */
    public validateCknr(cknr: string, zip: string, options?: any) {
        return ValidationsApiFp(this.configuration).validateCknr(cknr, zip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validate email
     * @param {string} email email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationsApi
     */
    public validateEmail(email: string, options?: any) {
        return ValidationsApiFp(this.configuration).validateEmail(email, options).then((request) => request(this.axios, this.basePath));
    }

}


